import { CellContext } from '@tanstack/react-table';
import { Copy } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@@/buttons';

import { Tag } from '../types';
import { CloneTagModal } from '../CloneTagModal';
import { getTableMeta } from '../meta';

import { helper } from './helper';

export const actions = helper.display({
  header: 'Actions',
  cell: ActionsCell,
});

function ActionsCell({
  table,
  row: { original: item },
}: CellContext<Tag, unknown>) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const meta = getTableMeta(table.options.meta);

  // Only show clone button if user has update permissions
  if (!meta.canUpdate) {
    return null;
  }

  return (
    <>
      <Button
        color="link"
        icon={Copy}
        onClick={() => setIsModalOpen(true)}
        disabled={meta.actionsDisabled}
        data-cy={`clone-tag-${item.Name}`}
      >
        Clone
      </Button>

      <CloneTagModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        sourceTag={item.Name}
      />
    </>
  );
}
